import { lazy, Suspense, type ReactNode } from "react";
import { useStoreContext } from "@/hooks/useStoreContext";
import { PageLoader } from "@/components/ui/page-loader";

// Chargé à la demande : seul le compte support le voit jamais, inutile d'alourdir
// le paquet principal de tous les autres (QR code compris).
const SupportMfaScreen = lazy(() =>
  import("@/components/support/SupportMfaScreen").then((module) => ({ default: module.SupportMfaScreen })),
);

/**
 * Le mode support exige la double authentification (migration
 * 20261002120000). Monté dans `ProtectedRoute`, sous `StoreProvider` : pour un
 * compte support dont le jeton n'est pas `aal2`, la page demandée est remplacée
 * par l'écran du code — ou, faute de facteur, par l'activation, imposée.
 *
 * Sans lui, le compte support monterait des pages que la base lui refuse en
 * aal1 : des écrans vides, sans erreur (constaté sur Creerbail le 05/09/2026).
 * Il ne protège rien à lui seul : la règle vit en base et dans les fonctions
 * edge. Franchisés et salariés ne le voient jamais.
 */
export function SupportMfaGate({ children }: { children: ReactNode }) {
  const { supportAdminLabel, authAssuranceLevel } = useStoreContext();

  if (!supportAdminLabel || authAssuranceLevel === "aal2") {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<PageLoader text="Chargement…" className="min-h-screen" />}>
      <SupportMfaScreen />
    </Suspense>
  );
}
